import { AuthResponse, UserState } from 'ducks/user'

export const parseAuthResponse = ({ jwt, user, provider }: AuthResponse): UserState => ({
  token: jwt,
  id: user.id,
  name: user.name || user.username,
  email: user.email,
  provider,
})
